import styled, {css} from "styled-components";

export const GamePlayPcHeaderBarRealDemoGameModeDefaultBox = styled.div<{isInRealMode: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    ${props => props.isInRealMode
    ? css`
                      background-color: ${props => props.theme.colors.gameModeRealBackground};
                `
    : css`
                      background-color: ${props => props.theme.colors.gameModeDemoBackground};
                `}
`